import ReducerRegistry from '../../base/redux/ReducerRegistry';
import { ASSISTANCE_BREAKOUT_ROOM_HANDLED, ASSISTANCE_BREAKOUT_ROOM_UNHANDLED, HIDE_ASSISTANCE_PANEL, SET_PARTICIPANT, SHOW_ASSISTANCE_PANEL, TOGGLE_ASSISTANCE_PANEL } from './actionTypes';
/**
 * Returns initial state for reactions' part of Redux store.
 *
 * @private
 * @returns {IReactionsState}
 */
function _getInitialState() {
    return {
        visible: false,
        assistancePanelVisible: false,
        breakOutRoomHandled: false,
        participant: undefined
    };
}
ReducerRegistry.register('features/inklusiva/rolematching', (state = _getInitialState(), action) => {
    switch (action.type) {
        case TOGGLE_ASSISTANCE_PANEL:
            return {
                ...state,
                assistancePanelVisible: !state.assistancePanelVisible
            };
        case SHOW_ASSISTANCE_PANEL:
            return {
                ...state,
                assistancePanelVisible: true
            };
        case HIDE_ASSISTANCE_PANEL:
            return {
                ...state,
                assistancePanelVisible: false
            };
        case ASSISTANCE_BREAKOUT_ROOM_HANDLED:
            return {
                ...state,
                breakOutRoomHandled: true
            };
        case ASSISTANCE_BREAKOUT_ROOM_UNHANDLED:
            return {
                ...state,
                breakOutRoomHandled: false
            };
        case SET_PARTICIPANT:
            return {
                ...state,
                participant: action.participant
            };
    }
    return state;
});
